import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MichiganButtons = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={4}
      sx={{
        flexGrow: 1,
        minHeight: 0,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Button
        sx={{
          width: { xs: '100%', md: 500 },
          height: { xs: 150, md: 300 },
          fontSize: { xs: '16px', md: '30px' },
          backgroundColor: 'var(--mi-secondary)',
          color: '#000000',
        }}
        variant='contained'
        href={process.env.REACT_APP_MICHIGAN_PLAYSLIP_FORM_URL}
      >
        {t('buttons.playslips_ticket_stock')}
      </Button>
      <Button
        sx={{
          width: { xs: '100%', md: 500 },
          height: { xs: 150, md: 300 },
          fontSize: { xs: '16px', md: '30px' },
          backgroundColor: 'var(--mi-primary)',
          color: '#FFFFFF',
        }}
        variant='contained'
        onClick={() => navigate('instants')}
      >
        {t('buttons.instants')}
      </Button>
    </Stack>
  );
};

export default MichiganButtons;
